import { FC, useEffect, useState } from 'react';
import { TableApi } from '../../../services/modules/table';
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { ProgressBar } from 'primereact/progressbar';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Nullable } from 'primereact/ts-helpers';
import moment from 'moment';
import styles from './FindDialog.module.css';
import tableStyle from '../../assets/table.module.css';
import { downloadFile } from '../../../utils/file';
export type TDataTableReadData = {
  header: Array<string>;
  table: {
    ins: Array<Array<any>>;
  };
};
/* eslint-disable no-unused-vars */
export const PowerProfileDialog: FC<{
  show: boolean;
  close: () => void;
  dataTableParams: TableApi.TDataTableReadParams<TDataTableReadData>;
}> = ({ show, close, dataTableParams }) => {
  const [data, setData] = useState<any[][]>([]);
  const [headers, setHeaders] = useState<string[]>([]);
  const [pending, setPending] = useState(false);
  const [complete, setComplete] = useState(false);
  useEffect(() => {
    if (
      dataTableParams.data &&
      'header' in dataTableParams.data &&
      dataTableParams.data.header
    ) {
      setHeaders(dataTableParams.data.header);
    }
    if (dataTableParams.progress.caption === 'Готово') {
      setPending(false);
      setComplete(true);
    }
    if (
      dataTableParams.data &&
      'table' in dataTableParams.data &&
      dataTableParams.data.table
    ) {
      // Преобразование в массив объектов
      const arrayOfObjects = dataTableParams.data.table.ins.map(
        (innerArray) => {
          const innerObject: any = {};
          innerArray.forEach((value, innerIndex) => {
            innerObject['t' + innerIndex] = value;
          });

          return innerObject;
        }
      );

      setData([...data, ...arrayOfObjects]);
    }
  }, [data, dataTableParams]);

  const startDay = moment().startOf('day').toDate();
  const now = moment().toDate();
  const [dates, setDates] = useState<Nullable<(Date | null)[]>>([
    startDay,
    now,
  ]);

  const handleDataTableExecute = () => {
    setData([]);
    setComplete(false);
    setPending(true);
    const zeroOutSeconds = (timestamp: number): number => {
      // Преобразуем временную метку в миллисекунды
      const date = new Date(timestamp * 1000);
      // Устанавливаем секунды и миллисекунды в 0
      date.setSeconds(0);
      date.setMilliseconds(0);
      // Преобразуем обратно в временную метку Unix (в секундах)

      return Math.floor(date.getTime() / 1000);
    };

    if (dates && dates[0] && dates[1]) {
      TableApi.dataTableExecute({
        tableName: 'power_profile',
        beginPeriod: zeroOutSeconds(dates[0].getTime() / 1000),
        endPeriod: zeroOutSeconds(dates[1].getTime() / 1000),
      });
    }
  };

  const handleDataTableAbort = () => {
    setPending(false);
    TableApi.dataTableAbort({ tableName: 'power_profile' });
  };

  const handleExport = async () => {
    const response = await TableApi.dataTableExport({
      format: 'excel',
      tableName: 'power_profile',
    });

    if (!response) return;

    const url = response.url;
    downloadFile(url)
  };

  const handleClosePowerProfile = () => {
    TableApi.dataTableAbort({ tableName: 'power_profile' });
    setTimeout(() => {
      close();
    }, 400);
  };

  const percent = (
    (dataTableParams.progress.pos / dataTableParams.progress.max) *
    100
  ).toFixed(0);
  return (
    <Dialog
      dismissableMask
      header={dataTableParams.tableCaption}
      visible={show}
      style={{ width: 1000 }}
      onHide={handleClosePowerProfile}
    >
      <div className={styles.searchForm}>
        <div style={{ display: 'flex', gap: 10 }}>
          <Calendar
            value={dates}
            dateFormat="dd/mm/yy"
            inputClassName={styles.inputText}
            style={{
              minWidth: 300,
            }}
            required
            onChange={(e) => setDates(e.value)}
            selectionMode="range"
            stepMinute={30}
            readOnlyInput
            showTime
          />
          <Button
            tooltip="Прочитать"
            disabled={pending}
            icon="pi pi-play"
            onClick={handleDataTableExecute}
          ></Button>
          <Button
            type="button"
            disabled={!pending}
            onClick={handleDataTableAbort}
            tooltip="Остановить"
            icon="pi pi-stop-circle"
            severity="secondary"
          ></Button>
          <Button
            type="button"
            tooltip="Экспорт"
            icon="pi pi-file-export"
            disabled={!complete}
            onClick={handleExport}
            severity="success"
          ></Button>
        </div>

        <div className={styles.description}>
          {dataTableParams.progress.caption}
        </div>

        <ProgressBar value={percent}></ProgressBar>
        <div
          className={tableStyle.tableContainer}
          style={{
            padding: 0,
          }}
        >
          <DataTable
            value={data}
            scrollable
            showGridlines
            className={tableStyle.table}
            virtualScrollerOptions={{
              itemSize: 57,
            }}
            scrollHeight="50dvh"
            emptyMessage=" "
          >
            {headers.map((col, idx) => (
              <Column key={idx} field={String('t' + idx)} header={col} />
            ))}
          </DataTable>
        </div>
      </div>
    </Dialog>
  );
};
